import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  personalize_page_load:false,
  personalize_meetingData:{},
  personalize_CTAData:{},
  personalize_AnnotationData : {},
  personalize_copyPasteData : {},
  personalize_leadgenFormData : {},
  personalize_pollData: {},
  personalize_brandingData: {},
  personalize_privacyData: {},
  personalize_triggerTime : [],
  personalize_thumbnailmodal : false,
  personalize_overlayTemplateData : [],
  personalize_reports : {}
};

const personalizeSlice = createSlice({
  name: "personalize",
  initialState,
  reducers: {
    resetState(state) {
      state.personalize_page_load = false;
      state.personalize_meetingData = {};
      state.personalize_CTAData = {};
      state.personalize_AnnotationData = {};
      state.personalize_copyPasteData = {};
      state.personalize_leadgenFormData = {};
      state.personalize_pollData = {};
      state.personalize_brandingData = {};
      state.personalize_privacyData = {};
      state.personalize_triggerTime = [];
      state.personalize_thumbnailmodal = false;
      state.personalize_overlayTemplateData = [];
      state.personalize_emailContacts = [];
    },
    // preState(state, action) {
    //   state.camp_id = action.payload.camp_id;
    // },
    setPersonalizepageLoad(state, action) {
      state.personalize_page_load = action.payload.personalize_page_load;
    },
    setMeetingData(state,action) {
      // console.log(action)
      state.personalize_meetingData = action.payload.personalize_meetingData
    },
    setCTAData(state,action) {
      state.personalize_CTAData =action.payload.personalize_CTAData
    },
    setAnnotationData(state,action) {
      state.personalize_AnnotationData =action.payload.personalize_AnnotationData
    },
    setCopyPasteData(state,action) {
      state.personalize_copyPasteData =action.payload.personalize_copyPasteData
    },
    setLeadgenFormData(state,action){
      state.personalize_leadgenFormData = action.payload.personalize_leadgenFormData
    },
    setPollData(state,action){
      state.personalize_pollData = action.payload.personalize_pollData
    },
    setBrandingData(state,action){
      state.personalize_brandingData = action.payload.personalize_brandingData
    },
    setPrivacyData(state,action){
      state.personalize_privacyData = action.payload.personalize_privacyData
    },
    setTriggerTime(state,action){
      let new_arr = state.personalize_triggerTime;
      // console.log(new_arr)
          new_arr.push(action.payload.personalize_triggerTime)
      // console.log(new_arr)
      state.personalize_triggerTime = new_arr
    },
    setDeleteTriggerTime(state,action){
      let new_arr = state.personalize_triggerTime;
      var filtered = new_arr.filter(function(value){ 
        return value !== action.payload.personalize_triggerTime;
      });
      state.personalize_triggerTime = filtered
    },
    setPersonalizeThumbnailModal(state,action){
      state.personalize_thumbnailmodal = action.payload.personalize_thumbnailmodal
    },
    setOverlayData(state,action){
      // let overlayTemplateData = state.personalize_overlayTemplateData;
      
      //     overlayTemplateData.push(action.payload.overlayData)
      state.personalize_overlayTemplateData = action.payload.overlayData
    },
    setDeleteOverlayData(state,action){
      let overlayTemplateData = state.personalize_overlayTemplateData;
      let personalize_trigger = action.payload.personalize_trigger;
      var pattern  = new RegExp("[^0-9]");
      if(pattern.test(personalize_trigger)){
        // console.log(personalize_trigger,pattern.test(personalize_trigger))
        state.personalize_overlayTemplateData = overlayTemplateData.filter((item)=>item.type !== personalize_trigger)
      }else{
        // console.log(personalize_trigger,pattern.test(personalize_trigger))
        state.personalize_overlayTemplateData = overlayTemplateData.filter((item)=>item.id !== personalize_trigger)
      }
      
    },
    setEmailContacts(state,action){
      state.personalize_emailContacts= action.payload.personalize_emailContacts;
    },
    setReports(state,action){
      state.personalize_reports = action.payload.personalize_reports;
    }

    // makeSingleSlide(state, action) {
    //   state.single_layer = action.payload.single_layer_data;
    // },
  },
});

export const personalizeAction = personalizeSlice.actions;
export default personalizeSlice.reducer;
